import React, { useEffect, useState } from 'react'
import { Card, CardContent, StepLabel, Stepper, Step, Grid, Button, Typography, Divider, CircularProgress } from '@material-ui/core'
import { useVeiculoService } from 'hooks/useVeiculoService'
import useRouter from 'utils/useRouter'
import { Page, Header } from 'components'
import { BackButton } from 'components/BackButton/BackButton'
import { Espelho } from 'components/Espelho'
import { useFormState } from 'hooks/useFormState'
import { FormLocalDeColeta } from 'components/FormLocalDeColeta'
// import { getLabelEndereco } from '../../../helpers/labels'
import { DadosVeiculo } from './components/DadosVeiculo'

import useStyles from './styles'
import { FormArquivos } from './components/FormArquivos'
import { useParams } from 'react-router'
import { Form as EditLocalForm } from 'views/Locais/EditarLocal/components/Form/Form'

const schema = {
  descricao: {
    presence: { allowEmpty: false, message: '^Descrição é obrigatório' },
  },
  endOrig: {
    presence: { allowEmpty: false, message: '^O local é obrigatório' },
  },
}

export const EditarVeiculo = (props) => {
  const { route } = props
  const router = useRouter()
  const veiculoService = useVeiculoService()
  const classes = useStyles()
  const params = useParams()
  const [activeStep, setActiveStep] = useState(0)
  const [hideNavigationButtons, setHideNavigationButtons] = useState(false)
  const [formularioComErro, setFormularioComErro] = useState(false)
  const [localAtualizado, setLocalAtualizado] = useState(null)
  const [abrirEspelho, setAbrirEspelho] = useState(false)
  const veiculoForm = useFormState(schema, {
    placa: '',
    marca: '',
    modelo: '',
    descricao: '',
    arquivos: [],
  })

  const [processandoVeiculo, setProcessandoVeiculo] = useState(false)
  const [veiculoSelecionado, setVeiculoSelecionado] = useState(null)

  useEffect(() => {
    const fetchVeiculoEditar = async () => {
      const result = await veiculoService.listarVeiculoDetalhadoAsync(params.id, setProcessandoVeiculo)
      setVeiculoSelecionado(result)
    }

    if (route.editar) {
      fetchVeiculoEditar()
    } else {
      veiculoForm.resetFormValues({ placa: '', marca: '', modelo: '', descricao: '', arquivos: [] })
    }
  }, [])

  useEffect(() => {
    if (veiculoSelecionado) {
      veiculoForm.setFormState((formState) => ({
        ...formState,
        values: {
          placa: veiculoSelecionado.placa,
          marca: veiculoSelecionado.marca,
          modelo: veiculoSelecionado.modelo,
          endOrig: veiculoSelecionado.endOrig,
          descricao: veiculoSelecionado.descricao,
          arquivos: veiculoSelecionado.arqs ? veiculoSelecionado.arqs.map((arquivo) => arquivo.id) : [],
        },
      }))
    }
  }, [veiculoSelecionado])

  const handleProximaEtapa = async () => {
    if (activeStep === 0) {
    }
    if (activeStep === 1) {
    }
    if (activeStep === 2) {
      setAbrirEspelho(true)
    } else {
      setActiveStep(activeStep + 1)
    }
  }

  const handleEtapaAnterior = () => {
    if (activeStep === 0) return
    setActiveStep(activeStep - 1)
  }

  const handleConfirmar = async () => {
    if (route.editar) {
      await veiculoService.editarVeiculo(params.id, veiculoForm.formState.values)
      router.history.push(`/casos/caso/veiculo/detalhar/${veiculoSelecionado.id}`)
    } else {
      const result = await veiculoService.cadastrarVeiculo(params.idCaso, veiculoForm.formState.values)
      router.history.push(`/casos/caso/detalhar/${params.idCaso}`)
    }
  }

  useEffect(() => {
    if (activeStep === 0 && veiculoForm.formState.errors.descricao) {
      setFormularioComErro(true)
      return
    }

    if (activeStep === 1 && veiculoForm.formState.errors.endOrig) {
      setFormularioComErro(true)
      return
    }

    if (activeStep === 1 && veiculoSelecionado && veiculoSelecionado.endOrig && localAtualizado === null) {
      setFormularioComErro(true)

      return
    }

    setFormularioComErro(false)
  }, [veiculoForm.formState.errors.descricao, veiculoForm.formState.errors.endOrig, activeStep, localAtualizado])

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      {processandoVeiculo ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <>
          <Card className={classes.results}>
            <CardContent>
              <Stepper alternativeLabel activeStep={activeStep}>
                <Step key="Dados do veículo">
                  <StepLabel>Dados do veículo</StepLabel>
                </Step>
                <Step key="Dados do local">
                  <StepLabel>Dados do local</StepLabel>
                </Step>
                <Step key="Arquivos relacionados">
                  <StepLabel>Arquivos relacionados</StepLabel>
                </Step>
              </Stepper>
              {activeStep === 0 && (
                <Grid container>
                  <Grid item md={12} sm={12} xs={12}>
                    <Typography variant="h5" gutterBottom>
                      DADOS DO VEÍCULO
                    </Typography>
                  </Grid>
                  <Grid item md={12} sm={12} xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item md={12} sm={12} xs={12}>
                    <DadosVeiculo form={veiculoForm} />
                  </Grid>
                </Grid>
              )}
              {activeStep === 1 && (
                <Grid container>
                  <Grid item md={12} sm={12} xs={12}>
                    <Typography variant="h5">DADOS DO LOCAL</Typography>
                  </Grid>
                  <Grid item md={12} sm={12} xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item md={12} sm={12} xs={12}>
                    {veiculoSelecionado && veiculoSelecionado.endOrig ? (
                      <EditLocalForm local={veiculoSelecionado.endOrig} setLocalAtualizado={setLocalAtualizado} veiculo={veiculoSelecionado && veiculoSelecionado.id ? veiculoSelecionado : null} idCaso={veiculoSelecionado && veiculoSelecionado.id ? null : params.idCaso} />
                    ) : (
                      <FormLocalDeColeta form={veiculoForm} idVeiculo={veiculoSelecionado && veiculoSelecionado.id ? veiculoSelecionado.id : null} idCaso={veiculoSelecionado && veiculoSelecionado.id ? null : params.idCaso} setDisableNextButton={setHideNavigationButtons} />
                    )}
                  </Grid>
                </Grid>
              )}
              {activeStep === 2 && (
                <Grid container>
                  <Grid item md={12} sm={12} xs={12}>
                    <Typography variant="h5">ARQUIVOS RELACIONADOS</Typography>
                  </Grid>
                  <Grid item md={12} sm={12} xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item md={12} sm={12} xs={12}>
                    <FormArquivos veiculoForm={veiculoForm} />
                  </Grid>
                </Grid>
              )}
              {!hideNavigationButtons && (
                <Grid container justifyContent="space-between">
                  <Grid item>
                    {activeStep === 0 ? (
                      <BackButton />
                    ) : (
                      <Button color="secundary" variant="contained" onClick={handleEtapaAnterior} className={classes.botoesFormulario}>
                        Etapa anterior
                      </Button>
                    )}
                  </Grid>
                  <Grid item>
                    <Button variant="contained" onClick={handleProximaEtapa} className={classes.botoesFormulario} color="secondary" disabled={formularioComErro}>
                      {activeStep === 2 ? 'Finalizar' : 'Próxima Etapa'}
                    </Button>
                  </Grid>
                </Grid>
              )}
            </CardContent>
          </Card>
          <Espelho aberto={abrirEspelho} setAberto={setAbrirEspelho} handleConfirmar={handleConfirmar} titulo="CONFIRMAÇÃO DOS DADOS PREENCHIDOS">
            <Grid item md={12} sm={12} xs={12}>
              <Typography>
                <b>INFORMAÇÕES GERAIS</b>
              </Typography>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Divider />
            </Grid>
            <Grid item container md={12} sm={12} xs={12} style={{ padding: '10px' }}>
              <Grid item md={4} sm={12} xs={12}>
                <Typography>
                  <b>Placa</b>
                </Typography>
                <Typography>{veiculoForm.formState.values.placa ? veiculoForm.formState.values.placa : 'Não informado'}</Typography>
              </Grid>
              <Grid item md={4} sm={5} xs={12}>
                <Typography>
                  <b>Marca</b>
                </Typography>
                <Typography>{veiculoForm.formState.values.marca ? veiculoForm.formState.values.marca : 'Não informado'}</Typography>
              </Grid>
              <Grid item md={4} sm={5} xs={12}>
                <Typography>
                  <b>Modelo</b>
                </Typography>
                <Typography>{veiculoForm.formState.values.modelo ? veiculoForm.formState.values.modelo : 'Não informado'}</Typography>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <Typography>
                  <b>Descrição</b>
                </Typography>
                <Typography>{veiculoForm.formState.values.descricao}</Typography>
              </Grid>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Typography>
                <b>DADOS DE ORIGEM</b>
              </Typography>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Divider />
            </Grid>
            <Grid item container md={12} sm={12} xs={12} style={{ padding: '10px' }}>
              <Grid item md={12} sm={12} xs={12}>
                <Typography>
                  <b>Local associado</b>
                </Typography>
                <Typography>
                  {veiculoForm.formState.values.endOrig && localAtualizado === null
                    ? `${veiculoForm.formState.values.endOrig.rua}, ${veiculoForm.formState.values.endOrig.numero} - ${veiculoForm.formState.values.endOrig.bairro} - ${veiculoForm.formState.values.endOrig.cidade}/${veiculoForm.formState.values.endOrig.estado}`
                    : localAtualizado !== null
                    ? `${localAtualizado.logradouro}, ${localAtualizado.numero} - ${localAtualizado.bairro} - ${localAtualizado.municipio.nome}/${localAtualizado.estado}`
                    : 'Não informado'}
                </Typography>
              </Grid>
            </Grid>
          </Espelho>
        </>
      )}
    </Page>
  )
}
